import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sh-platform-state-indicator',
  templateUrl: './platform-state-indicator.component.html',
  styleUrl: './platform-state-indicator.component.scss',
  standalone: false
})
export class PlatformStateIndicatorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
